import React, { FC } from 'react';
import { Typography } from '@mui/material';
import styles from './MeasurementsComponent.module.scss';
import DataList, { DataListItem } from '../DataList/DataList';

interface MeasurementsComponentProps {
    measurements: DataListItem[]
}

const MeasurementsComponent: FC<MeasurementsComponentProps> = (props) => {
    const { measurements } = props;

    return (
        <div className={styles.MeasurementsComponent} data-testid="MeasurementsComponent">
            <Typography
                variant="h1"
                sx={{ pb: 4 }}
            >
                Measurements
            </Typography>
            <DataList dataListItems={measurements} />
        </div>
    );
};

export default MeasurementsComponent;
